import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Redirect, useHistory } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import * as Cookies from "js-cookie";
import Input from "@material-ui/core/Input";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import * as CryptoJS from "crypto-js";
import { calcMD5 } from "src/md5Forgot.js";
import Api from "src/network/index.js";
import ForgotPassword from "../ForgotPassword";
import FbAuth from "../FbAuth.js";
import apple from "src/Assets/images/LandingPageImages/apple.png";
import * as SignInActions from "src/store/actions/SignInActions/SignInAction.js";
import { emailRegex } from "src/Constants/regex";
import style from "./SignIn.module.css";
import AppleLogin from "react-apple-login";
import "src/Assets/css/LandingPage/LandingPage.css";
import GoogleSignUp from "../GoogleSignUp";
import { AppleButton } from "../SocialButtons";
import AppleSignUp from "../AppleSignUp";
import DefaultCommunityChangePage from "./DefaultCommunityChangePage";
import * as ForgotpassAction from "src/store/actions/Forgotpassword/ForgotpassAction";
// const AppleClientId = 'com.skopic.web'; // Service Id
// const AppleRedirectUri = 'https://dev.skopic.com/About' // Your redirect URI

// const AppleClientId = 'com.iphone.skopic.service';
// const AppleRedirectUri = 'https://skopic.com/apple/redirect_url.html';

import { extractCommunityInfo } from "src/Utils/extractCommunityInfo";

const baseURL = process.env.REACT_APP_SERVICES_API_OTHER;
const AppleClientId = process.env.REACT_APP_APPLE_CLIENT_ID; // Service Id
const AppleRedirectUri = `${baseURL}/jsonindex/apple-id`; // Your redirect URI

const schema = yup.object().shape({
  email: yup
    .string()
    .matches(emailRegex, "Please enter a valid Email.")
    .required("Email address is required"),
  password: yup
    .string()
    .typeError("Please enter the password.")
    .required("Please enter the password.")
    .min(8, "Password should be minimum 8 characters"),
});

function SignIn() {
  const dispatch = useDispatch();
  const history = useHistory();
  const emailAction = useSelector((state) => state.emailActionReducer);
  const { invitedEmailId } = extractCommunityInfo(emailAction);
  const SignInReducer = useSelector((state) => state.SignInReducer);
  const {
    isloading: loadingStatus,
    errorMessage: message,
    isAuthorized: authenticationVerficationStatus,
    isAuthenticating,
    SignInCheckData,
    userDetails,
  } = SignInReducer || {};

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isEmailAndPasswordField, setEmailAndPasswordField] = useState(false);
  const [isUserBlocked, setIsUserBlocked] = useState(null);
  const signInStatus = Cookies.get("signInStatus");
  const [showTempPasswordModal, setShowTempPasswordModal] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState("");
  const userFollowingCommunityListCount =
    userDetails?.userData?.communityFollowNames?.length ?? 0;

  const methods = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
    resolver: yupResolver(schema),
  });
  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    trigger,
    formState: { errors },
  } = methods;

  const [isForgotPswdClicked, setIsForgotPswdClicked] = useState(false);

  useEffect(() => {
    if (signInStatus !== "true" && authenticationVerficationStatus !== true) {
      history.push("/");
      return;
    }
    if (
      (SignInCheckData?.userTenant === "tenant_blocked" ||
        SignInCheckData?.userTenant === "Inactive Tenant") &&
      userFollowingCommunityListCount === 1
    ) {
      history.push("/defaultCommunity");
    }
  }, [
    signInStatus,
    authenticationVerficationStatus,
    SignInCheckData?.userTenant,
    userFollowingCommunityListCount,
    history,
  ]);

  const maskEmail = (email) => {
    const str = email.split("");
    let finalArr = [];
    const len = str.indexOf("@");
    str.forEach((item, pos) => {
      pos >= 1 && pos <= len - 2 ? finalArr.push("*") : finalArr.push(str[pos]);
    });
    finalArr.join("");
    return finalArr;
  };
  const activiationStatusCheckHandler = async () => {
    try {
      // const isValid = await trigger("email");
      // if (!isValid) return;
      const email = getValues()?.email;
      if (email) {
        let formData = new FormData();
        formData.append("email", email);
        await Api.validateActivationStatus(formData);
      }
    } catch (e) {
      console.error(e);
    }
  };
  const activiationCheckHandler = async () => {
    try {
      const email = getValues()?.email;
      if (!email) return;

      let formData = new FormData();
      formData.append("mail", email);

      const validationRes = await Api.validateTempUserEmail(formData);
      console.log("validateTempUserEmail response:", validationRes); // check response shape here
      const status = validationRes?.data?.status;
      if (status === "passwordSetup") {
        // dispatch(ForgotpassAction.NewForgotpass(email));
        const forgotPasswordApiRes = await Api.forgotMyPassword(email);
        console.log(`forgotPasswordApiRes:`, forgotPasswordApiRes);
        if (forgotPasswordApiRes?.data?.status === "Success") {
          const maskedEmail = maskEmail(email);
          setMaskedEmail(maskedEmail);
          setShowTempPasswordModal(true);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const submitHandler = (data) => {
    const { email, password } = data || {};
    if (email !== "" && password !== "") {
      setEmailAndPasswordField(true);
    }
    // e.preventDefault();
    let encodedEmail = CryptoJS.AES.encrypt(email, "skopic").toString();
    let encodedPassword = calcMD5(password);
    let formData = new FormData();
    formData.append("j_username", encodedEmail);
    formData.append("j_password", encodedPassword);
    formData.append("si_remember", "_spring_security_remember_me=true");

    dispatch(SignInActions.signinUser(formData));
    dispatch(SignInActions.loading());
    setIsUserBlocked(true);
  };

  // const buttonDisablerHandler = () => {
  //   if (
  //     !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ||
  //     pwdCr.password.length < 8
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  // let isEnabled = buttonDisablerHandler();

  const handlePasswordVisibility = () => {
    setIsPasswordVisible((isPasswordVisible) => !isPasswordVisible);
  };

  const onCloseDefaultCommunitykModal = () => {
    setIsUserBlocked(false);
    if (
      userDetails?.userData?.communityStatus === "communityBlocked" ||
      userDetails?.userData?.currentCommunityStatus == 0
    ) {
      dispatch(SignInActions.signOut());
    }
  };

  const onMouseDown = (event) => {
    event.preventDefault();
  };

  const handleAppleSignIn = () => {
    // appleKeyId=8F33F9LRD3
    // appleTeamId=WUZBEW4298
    // appleClientId =com.skopic.ios
    const scope = "name email"; // Adjust as necessary
    const state = Math.random().toString(36).substring(2); // Random state for CSRF protection
    const responseType = "code"; // Can also be 'id_token'
    const responseMode = "form_post";
    const url = `https://appleid.apple.com/auth/authorize?response_type=${responseType}&client_id=${AppleClientId}&redirect_uri=${AppleRedirectUri}&state=${state}&scope=${scope}&response_mode=${responseMode}`;
    window.location.href = url; // Redirect to Apple Sign In
  };

  const onSuccess = async (response) => {
    console.log("RESPONSE->>", response?.authorization?.code);
    if (!response?.error) {
      let formdata = new FormData();
      formdata.append("oAuthCode", response?.authorization?.code);
      formdata.append("appType", "web");
      try {
        const result = await Api.appleSignup(formdata);
        const { status } = result?.data || {};
        if (
          status &&
          String(status).toLowerCase() ===
            "Thank you for Signing using your appleid account".toLowerCase()
        ) {
          Cookies.set("signInStatus", true);
          await Api.getUserData(
            result.data?.userTenantId,
            result.data?.userTenant,
          );
          sessionStorage.setItem("userData", JSON.stringify(result));
          history.push("/Home");
        }
      } catch (e) {
        console.error(e);
      }
      console.log("RESPONSE->>", response);
    } else {
      console.log("ERROR->>", response);
    }
  };

  const onError = (error) => {
    console.error("Apple Sign In Error:", error);
  };

  // if (
  //   authenticationVerficationStatus &&
  //   SignInCheckData?.userTenant !== "tenant_blocked"
  // ) {
  //   return <Redirect to="/Home" />;
  // }

  return (
    <React.Fragment>
      <div className={style.Signin}>
        <div className={style.SigninFrom}>
          <form
            onSubmit={handleSubmit(submitHandler)}
            className={style.formstyle}
          >
            <div className={style.SigninFromEmail}>
              <Controller
                name="email"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Input
                    type="text"
                    name="email"
                    placeholder="Email"
                    value={value}
                    onChange={onChange}
                    onBlur={activiationCheckHandler}
                    className={style.textField}
                    inputProps={{ maxLength: 50 }}
                  />
                )}
              />
            </div>
            {errors?.email && (
              <p className={style.ErrorMsg}>{errors?.email?.message}</p>
            )}
            <div className={style.SigninFromPassword}>
              <Controller
                name="password"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Input
                    type={isPasswordVisible ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    value={value}
                    onChange={onChange}
                    // onFocus={activiationCheckHandler}
                    className={style.textField}
                    inputProps={{ maxLength: 32 }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handlePasswordVisibility}
                          onMouseDown={onMouseDown}
                          edge="end"
                        >
                          {isPasswordVisible ? (
                            <IoEyeOutline />
                          ) : (
                            <IoEyeOffOutline />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                )}
              />
            </div>
            {errors?.password && (
              <p className={style.ErrorMsg}>{errors?.password?.message}</p>
            )}
            <p className={style.ForgotPassowrd}>
              <ForgotPassword setIsForgotPswdClicked={setIsForgotPswdClicked} />
            </p>
            <button
              type="submit"
              // disabled={isEnabled}
              disabled={isAuthenticating}
              className={style.SigninButton}
            >
              {loadingStatus && !isForgotPswdClicked ? (
                <CircularProgress style={{ width: "20px", height: "20px" }} />
              ) : (
                <>Sign In</>
              )}
            </button>
            {/* <p className={style.StatusMessage}>{message}</p> */}
            {isEmailAndPasswordField && (
              <p className={style.StatusMessage}>{message}</p>
            )}
          </form>
        </div>
        <div className={style.Changesignin}>
          <div className={style.line} />
          <span>or</span>
          <div className={style.line} />
        </div>
        <div className={style.SocialIcon}>
          {/* <img
            src={google_new}
            alt="googleImage"
            className={style.SocailImage}
          />
          <img
            src={facebook}
            alt="FacebookImage"
            className={style.SocailImage}
          /> */}
          <GoogleSignUp />
          <div style={{ margin: "4px 0px" }} />
          <AppleSignUp />
          {/* <AppleButton onClick={handleAppleSignIn} /> */}
          {/* <AppleLogin
            clientId={AppleClientId} // Your Services ID
            redirectURI={AppleRedirectUri} // Your redirect URI
            responseType="code" // Or 'id_token'
            responseMode="form_post"
            onSuccess={onSuccess}
            onError={onError}
          /> */}
          {/* <AppleLogin
            clientId={AppleClientId} // Your Services ID
            redirectURI={AppleRedirectUri} // Your redirect URI
            usePopup={true}
            callback={onSuccess} // Catch the response
            scope="email name"
            responseMode="query"
            render={renderProps => (  //Custom Apple Sign in Button
              <AppleButton onClick={renderProps.onClick} />
            )}
          /> */}
        </div>
      </div>
      {(SignInCheckData?.userTenant === "tenant_blocked" ||
        SignInCheckData?.userTenant === "Inactive Tenant") &&
        userFollowingCommunityListCount > 1 && (
          <DefaultCommunityChangePage
            isUserBlocked={isUserBlocked}
            onCloseDefaultCommunitykModal={onCloseDefaultCommunitykModal}
            userDetails={userDetails}
          />
        )}
      {showTempPasswordModal && (
        <Modal
          open={showTempPasswordModal}
          onClose={() => setShowTempPasswordModal(false)}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 410,
              height: 230,
              bgcolor: "background.paper",
              borderRadius: "16px",
              textAlign: "center",
              boxShadow: 24,
              pt: 4,
              px: 4,
              pb: 3,
            }}
          >
            <h5>
              A temporary password
              <br /> has been sent to
            </h5>
            <p>{maskedEmail}</p>
            <Button
              variant="text"
              style={{ color: "grey", fontSize: "0.938rem" }}
              onClick={() => setShowTempPasswordModal(false)}
            >
              Ok
            </Button>
          </Box>
        </Modal>
      )}
    </React.Fragment>
  );
}

export default SignIn;
